import React from 'react';
import Navigation from "../../routing/Navigation";
import { Link } from "react-router-dom";
import { Nav, Navbar, NavItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import './Header.css';

const Header = (props) => {

  return (
    <Navbar collapseOnSelect className="bo-navbar">
      <Navbar.Header>
        <Navbar.Brand className="bo-navbar-brand">
          <Link to="/">
            <span className="bo-name bo-name-first">JULIUS</span><br /><span className="bo-name bo-name-last">POPA</span>
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle></Navbar.Toggle>
      </Navbar.Header>
      <Navbar.Collapse>
        <Nav pullRight className="bo-navbar-nav">
          {Navigation.map(navItem => {
            return (
              <LinkContainer to={`/${navItem.category}`} key={navItem.id}>
                <NavItem>
                  {navItem.name.map((name, index) => {
                    if (index !== navItem.name.length - 1) return <span key={index}>{name}<br /></span>
                    else return <span key={index}>{name}</span>
                  })}
                </NavItem>
              </LinkContainer>
            )
          })}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}



export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/Header.js